import Bddvd from "./bddvd/main.es6";

const bddvd = new Bddvd();
